import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NavActions from '../../actions';

export default class EpicGamesToggle extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            hoverTriangle: false
        };
    }

    static propTypes = {
        shieldOnClick: PropTypes.func
    };

    static contextTypes = {
        isMobile: PropTypes.bool,
        isTablet: PropTypes.bool,
        isDesktop: PropTypes.bool,
        messages: PropTypes.object,
        globalLinkOnClick: PropTypes.func
    };

    onClick = (e) => {
        const currentTarget = e.currentTarget || {};
        const href = currentTarget.href;
        let globalReturnValue = null;
        if (this.context.globalLinkOnClick && typeof this.context.globalLinkOnClick === 'function') {
            globalReturnValue = this.context.globalLinkOnClick(e, href);
        }

        if (globalReturnValue !== false) {
            if (this.props.shieldOnClick && this.props.shieldOnClick && typeof this.props.shieldOnClick === 'function') {
                this.props.shieldOnClick(e);
            }
        }

        NavActions.closeMobileTablet.defer();
    };

    mouseLeaveTriangle = () => {
        this.setState({
            hoverTriangle: false
        });
    };

    mouseEnterTriangle = () => {
        this.setState({
            hoverTriangle: true
        });
    };

    render() {
        const btnClass = classNames('egLogo', {'cursor-pointer': true});
        // Suppress mouse and click events when we are hiding the dropdown
        const btnConfig = {
            role: 'button',
            tabIndex: '0'
        };
        const shieldLogoClass = classNames('shieldLogo text-color bg-color text-color-border-after', {
            'mouse-over': this.state.hoverTriangle
        });

        return (
            <div
                id="egLogo"
                className={btnClass}
                {...btnConfig}>
                <a href="https://www.epicgames.com" title="Epic Games" className={shieldLogoClass} onClick={this.onClick} />
            </div>
        );
    }
}
